import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesReportes() {
  const { user } = useContext(AuthContext);

  const SECCIONES = [
    { section: null, items: [
      { label: "Reportes Ventas", icon: "fas fa-chart-line", color: "#10b981", href: "/MenuReportesVentas", desc: "Analisis comercial", enabled: !!user.menu_reportes },
      { label: "Reportes Admin", icon: "fas fa-dollar-sign", color: "#6366f1", href: "/MenuReportesAdmin", desc: "Cobranza y saldos", enabled: !!user.menu_reportes },
      { label: "Dashboards", icon: "fas fa-chart-bar", color: "#8b5cf6", href: "/Dashboards", desc: "Tableros graficos", enabled: !!user.menu_reportes },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Reportes"
      descripcion="Analisis de ventas, administracion y tableros"
      icono="fas fa-chart-bar"
      color="#8b5cf6"
      secciones={SECCIONES}
    />
  );
}

export default BotonesReportes;
